module.exports = __webpack_public_path__ + "static/media/price-list-header.2314860c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price-list-header.png
// module id = 635
// module chunks = 0